import * as api from "../apis/setupTemplatesApi";
import {
  useQuery,
  useQueryClient,
  queryOptions,
  useSuspenseQuery,
} from "@tanstack/react-query";


// Query options

export const getSetupTemplatesQueryOptions = () =>
  queryOptions({
    queryKey: ["setupTemplates"],
    queryFn: api.getSetupTemplates,
    refetchOnWindowFocus: "always",
    
  });

export const getSetupTemplatesByAdAccountQueryOptions = (
  adAccountId,
  queryClient
) =>
  queryOptions({
    queryKey: ["adAccount.setupTemplates", adAccountId],
    queryFn: () => api.getSetupTemplatesByAdAccount(adAccountId),
    refetchOnWindowFocus: "always",
    
    initialData: () =>
      queryClient
        .getQueryData(["setupTemplates"])
        ?.filter((setupTemplate) => setupTemplate.adAccount.id === adAccountId),
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(["setupTemplates"])?.dataUpdatedAt,
  });

export const getSetupTemplateQueryOptions = (id, queryClient) => {
  let queryKey;

  return queryOptions({
    queryKey: ["setupTemplate", id],
    queryFn: () => api.getSetupTemplate(id),
    refetchOnWindowFocus: "always",
    
    initialData: () => {
      // if "setupTemplates" query exist, we use it to init data
      if (queryClient.getQueryState(["setupTemplates"])) {
        queryKey = ["setupTemplates"];
        return queryClient
          .getQueryData(["setupTemplates"])
          ?.find((setupTemplate) => setupTemplate.id === id);
      }

      // otherwise, we try to find the setupTemplate in one of the "account.setupTemplates" queries
      let found;

      queryClient
        .getQueriesData({ queryKey: ["account.setupTemplates"] })
        .forEach((query) => {
          const data = query[1];
          data.forEach((setupTemplate) => {
            if (setupTemplate.id === id) {
              found = setupTemplate;
              queryKey = query[0];
            }
          });
        });

      // otherwise, we try to find the setupTemplate in one of the "adAccount.setupTemplates" queries
      if (!found) {
        queryClient
          .getQueriesData({ queryKey: ["adAccount.setupTemplates"] })
          .forEach((query) => {
            const data = query[1];
            data.forEach((setupTemplate) => {
              if (setupTemplate.id === id) {
                found = setupTemplate;
                queryKey = query[0];
              }
            });
          });
      }

      return found;
    },
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
};

// useQuery

export const useGetSetupTemplates = () => useQuery(getSetupTemplatesQueryOptions());

export const useGetSetupTemplatesByAdAccount = (adAccountId) => {
  const queryClient = useQueryClient();
  return useQuery(
    getSetupTemplatesByAdAccountQueryOptions(adAccountId, queryClient)
  );
};

export const useGetSetupTemplate = (id) => {
  const queryClient = useQueryClient();
  return useQuery(getSetupTemplateQueryOptions(id, queryClient));
};

// useSuspenseQuery

export const useSuspenseGetSetupTemplates = () =>
  useSuspenseQuery(getSetupTemplatesQueryOptions());

export const useSuspenseGetSetupTemplatesByAdAccount = (adAccountId) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(
    getSetupTemplatesByAdAccountQueryOptions(adAccountId, queryClient)
  );
};

export const useSuspenseGetSetupTemplate = (id) => {
  const queryClient = useQueryClient();
  return useSuspenseQuery(getSetupTemplateQueryOptions(id, queryClient));
};
